import { Routes } from '@angular/router';
import { AssetComponent } from './connector-ui/assets/shared/components/asset/asset.component';
import { CatalogComponent } from './connector-ui/catalog/shared/components/catalog/catalog.component';
import { connectorAdminGuard } from './auth/connector-admin.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'dashboard',
    canActivate: [connectorAdminGuard],
    loadChildren: () =>
      import('./connector-ui/dashboard/dashboard.module').then((m) => m.DashboardModule)
  },
  {
    path: 'catalog',
    component: CatalogComponent,
    canActivate: [connectorAdminGuard],
    loadChildren: () => import('./connector-ui/catalog/catalog.module').then((m) => m.CatalogModule)
  },
  {
    path: 'assets',
    component: AssetComponent,
    canActivate: [connectorAdminGuard],
    loadChildren: () => import('./connector-ui/assets/assets.module').then((m) => m.AssetsModule)
  },
  {
    path: 'connector',
    canActivate: [connectorAdminGuard],
    loadChildren: () =>
      import('./connector-ui/connector/connector.module').then((m) => m.ConnectorModule)
  },
  {
    path: 'contracts',
    canActivate: [connectorAdminGuard],
    loadChildren: () =>
      import('./connector-ui/contracts/contracts.module').then((m) => m.ContractsModule)
  },
  {
    path: 'policies',
    canActivate: [connectorAdminGuard],
    loadChildren: () =>
      import('./connector-ui/policies/policies.module').then((m) => m.PoliciesModule)
  },
  { path: '**', redirectTo: 'dashboard' }
];
